import BootstrapSpinner from 'react-bootstrap/Spinner'

export const Spinner = () => (
  <div className="d-flex align-items-center justify-content-center vh-100">
    <BootstrapSpinner animation="border" role="status" variant="primary">
      <span className="visually-hidden">Loading...</span>
    </BootstrapSpinner>
  </div>
)
